import { Vector2 } from "three/src/math/Vector2.js";


export class PointerTracker {
  id: string;
  pos: Vector2
  relPos: Vector2
  time: Date;
  pointer: PointerEvent

  __nearThreshold = 50

  constructor(x: number, y: number, pointer: PointerEvent) {
    this.pos = new Vector2(x,y)
    this.id = `${pointer.pointerId}`
    this.pointer = pointer
    this.time = new Date()
  }

  rel(x, y) {
    this.relPos = new Vector2(x, y)
  }

  isNear(x: number, y: number) {
    return (
      (Math.abs(this.pos.x - x) < this.__nearThreshold)
      && (Math.abs(this.pos.y - y) < this.__nearThreshold)
    )
  }

  toString(additional: string) {
    return `Input (${this.id}) at (${this.pos.x}, ${this.pos.y}) ${additional}`
  }
}